import React, { useEffect } from "react";
import { useSiteConfig } from "../../../hooks";
import "./PrintHeader.scss";

export function PrintHeader(props) {
  const { title, subtitle, children } = props;
  const { siteConfig, getSiteConfig } = useSiteConfig();

  useEffect(() => {
    getSiteConfig();
  }, []);

  return (
    <div className="print-header-admin">
      <span className="print-header-admin__business">
        {siteConfig?.site_name || "iCard"}
      </span>
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
      {children}
    </div>
  );
}
